import React from 'react'
import myImage from '../../images/town.svg'
import { Button } from '../ButtonElement'
import { 
    InfoContainer, 
    InfoWrapper, 
    InfoRow, 
    Column1, 
    Column2,
    TextWrapper, 
    TopLine, 
    Heading, 
    Subtitle, 
    BtnWrap, 
    ImgWrap, 
    Img
} from './infoElements'
const InfoSection = ({lightBg,id,imgStart, topLine, lightText, headline, darkText, description, buttonLabel, buttonPath, button2Label, button2Path, img, alt, primary, dark, dark2, lightTop}) => {
  return (
    <>
        <InfoContainer lightBg={lightBg} id={id}>
            <InfoWrapper>
                <InfoRow imgStart={imgStart}>
                    <Column1>
                        <TextWrapper>
                            <TopLine lightTop={lightTop}>{topLine}</TopLine>
                            <Heading lightText={lightText}>{headline}</Heading>
                            <Subtitle darkText={darkText}>{description}</Subtitle>  
                            <BtnWrap>
                                <a href= {buttonPath}><Button>{buttonLabel}</Button></a>    
                            </BtnWrap>
                            
                                {button2Label && button2Path && (
                                    
                                    <>
                                    
                                    <p></p>
                                    <BtnWrap>
                                        <a href={button2Path}>
                                            <Button>
                                                 {button2Label}
                                            </Button>
                                        </a>
                                        </BtnWrap>
                                  </>
                                    
                                )}
                            

                        </TextWrapper>
                    </Column1>
                    <Column2>
                        <ImgWrap>
                        
                        <Img  src={require(`../../images/${img}`)} alt={alt}/>
                            
                        </ImgWrap>
                     </Column2>
                </InfoRow>
            </InfoWrapper>

        </InfoContainer>
    </>
  )
}

export default InfoSection

function ExLink() {
    // 👇️ using window.location.href 👇️
    window.location.href = 'https://google.com';
    return null;
  }